import React, { useState } from "react";
import { Typography } from "@mui/material";

import GredCheck from "../../styles/svg/gred-check.svg";
import GreenCheck from "../../styles/svg/green-check.svg";
import useMutate from "../../hooks/useMutate";
import { assignCard } from "../../sevices/apiCards";
import FormDialog from "../Dialog/FormDialog";

function MarkAsCompleted({ changeStatus, loading, assignObject, assignedUserId }) {
  const [isHovered, setIsHovered] = useState(false);
  const [dialog, setDialog] = useState(false);
  const { mutate } = useMutate(assignCard,[],()=>{setDialog(false)});

  return (
    <>
      <img
        className="cursor-pointer ml-1"
        src={isHovered ? GreenCheck : GredCheck}
        onClick={(event) => {
          event.stopPropagation();
          if (assignedUserId) {
            setDialog(true);
          } else {
            changeStatus("Completed");
          }
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        alt="read-to-completed"
      />

      {dialog && (
        <FormDialog
          open={dialog}
          handleClose={() => {changeStatus("Completed");
            setDialog(false);}}
          handleSubmit={() => {
            changeStatus("Completed");
            mutate(assignObject);
          }}
          title="Confirm Assign Back?"
          buttonTxt="Yes"
          cancelBtn="No"
          cancelBtnTxt="No"
          alignActions="center"
          onClose={false}
          crossIconFunc={() => setDialog(false)}
          isLoading={loading}>
          <Typography>
            Do you want to assign this Quick Task back to the reporter?
          </Typography>
        </FormDialog>
      )}
    </>
  );
}

export default MarkAsCompleted;
